import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const GuidelineTransactionPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">取引の流れ</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              DONDONでは、すべての商品に対して真贋鑑定および検品を実施しており、お客様に安心・安全な取引環境をご提供しています。<br/>主な取引の流れは下記の通りです。<br/>
              また、取引に伴い発生する手数料の詳細や、想定されるトラブル・注意事項についてのご案内もあわせて記載しております。ご利用の際には、事前にご確認いただきますようお願いいたします。
            </div>
            <img className="w-full max-w-[482px] h-auto" src="/images/terms/guideline_transaction_1.jpg" alt="取引の流れ" />
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="w-full justify-center text-black text-2xl font-bold leading-9">取引において発生するさまざまな事象について</div>
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              取引の進行中には、出品者様・購入者様の双方にとって予期せぬ事象が発生する場合があります。<br/>
              そのような場合には、状況に応じてDONDONより当事者のいずれかにご連絡のうえ、確認や対応をお願いすることがございます。<br/>
              ※なお、取引相手に規約違反が確認された場合は、取引を事務局判断にてキャンセルとさせていただくことがございます。あらかじめご了承ください。
            </div>
            <div className="self-stretch inline-flex justify-start items-start gap-2.5">
              <div className="flex-1 flex justify-start items-start">
                <div className="justify-center text-black text-base font-normal leading-7">進行上のトラブルや対応方法については、</div>
                <Link to={`/terms/faq_trade_purchase_sell${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">よくある質問</Link>
                <div className="justify-center text-black text-base font-normal leading-7">をご確認ください。</div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="w-full justify-center text-black text-2xl font-bold leading-9">出品者の商品発送について</div>
            <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-base font-bold leading-7">出品者</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  取引成立後、72時間以内に商品発送をお願いいたします。<br/>
                  発送後は発送通知を忘れずにおこなってください。<br/>
                  72時間以内に商品が発送されずキャンセルになった場合や、発送通知を行わなかったことで期限が経過しキャンセルになった場合は、キャンセル料（商品代金の10%）が発生いたします。
                </div>
              </div>
              <div className="justify-center text-black text-base font-bold leading-7">購入者</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  出品者様には、取引成立後72時間以内に商品の発送をお願いしております。<br/>
                  万が一、期限内に発送が確認できない場合、購入者様側で取引のキャンセル手続きが可能となります。
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="w-full justify-center text-black text-2xl font-bold leading-9">DONDONへの商品到着期限について</div>
            <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-base font-bold leading-7">出品者</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  商品の発送からDONDONへの到着期限は、「発送通知日を含めて5日以内」となっております。<br/>
                  万が一、期限内にDONDONへ商品が到着しなかった場合は、購入者様側で取引のキャンセルが可能です。<br/>
                  取引がキャンセルとなった場合、キャンセル料（商品代金の10%）が発生いたしますので、あらかじめご了承ください。
                </div>
              </div>
              <div className="justify-center text-black text-base font-bold leading-7">購入者</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  出品者様による発送後、DONDONへの到着期限は「発送通知日を含めて5日以内」となっております。<br/>
                  商品の到着が確認され次第、DONDONより取引画面にて通知いたしますので、今しばらくお待ちください。
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="w-full justify-center text-black text-2xl font-bold leading-9">商品の鑑定・検品について</div>
            <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-base font-bold leading-7">出品者</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  商品がDONDONに到着した後は、鑑定士が順次、鑑定および検品を行います。<br/>
                  その過程で商品に不備が確認された場合には、出品者様へご連絡のうえ、内容の確認をお願いする場合がございます。<br/>
                  その他、よくある質問につきましては下記をご参照ください。
                </div>
              </div>
              <div className="justify-center text-black text-base font-bold leading-7">購入者</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  商品がDONDONに到着した後は、鑑定士が順次、商品の鑑定および検品を行います。<br/>
                  なお、鑑定・検品の過程で商品に不備が見つかった場合には、状況に応じてご連絡のうえ、取引継続のご意向を確認させていただくことがございます。<br/>
                  ※ご案内に記載された期日を過ぎた後のご希望（取引継続・キャンセルなど）については、対応いたしかねます。あらかじめご了承ください。
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="w-full justify-center text-black text-2xl font-bold leading-9">鑑定後の商品発送について</div>
            <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-base font-bold leading-7">出品者</div>
              <div className="self-stretch pl-5 flex flex-col justify-center items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                  当社が定める鑑定・検品の基準を満たした商品については、鑑定完了後に取引画面上で通知をお送りします。<br/>
                  鑑定の完了とともに、出品者様のアカウントへ売上金が付与され、取引が完了となります。
                </div>
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">売上金や振込に関する詳細については、以下のページをご確認ください。</div>
                  <Link to={`/terms/sale_transfer${location.search}`} className="self-stretch justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">売上金・振込について</Link>
                </div>
              </div>
              <div className="justify-center text-black text-base font-bold leading-7">購入者</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  当社の基準を満たした証明として、商品に鑑定済シールを貼付して発送いたします。<br/>
                  配送時の追跡番号については、DONDONからの発送手配が完了すると取引画面に表示されます。<br/>
                  商品の発送に関するお届け先の変更や日時指定をご希望の場合は、ヤマト運輸へ直接ご相談ください。
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="w-full justify-center text-black text-2xl font-bold leading-9">購入者への商品到着について</div>
            <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-base font-bold leading-7">購入者</div>
              <div className="self-stretch pl-5 flex flex-col justify-center items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                  DONDONから商品を発送した後、お届けまでには通常1〜2日程度のお時間を頂戴しております。<br/>
                  ※お届け先の地域や天候等の影響により、前後する場合がございます。
                </div>
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                  なお、DONDONからの発送完了後、5日が経過しますと、システムにより自動で取引が完了いたします。<br/>
                  お手続き等のご連絡は不要ですので、あらかじめご了承ください。
                </div>
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                  お届けした商品に万が一不備があった場合は、お手数ですがお問い合わせフォームよりご連絡をお願いいたします。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default GuidelineTransactionPage;